<template>
    <div style="background-color: white;">
        <div style="padding: 20px; display: flex; flex-direction: column;">
            <div style="font-size: 16px; font-weight: bold; margin-bottom: 10px;">体检人员：</div>
            <div v-for="item in memberList" :key="item.memberId" style="margin-bottom: 10px;">{{item.joinRelation}}：<span style="float: right">{{item.joinName}}</span></div>
        </div>
        <div style="padding: 20px; display: flex; flex-direction: column;">
            <div style="font-size: 16px; font-weight: bold; margin-bottom: 10px;">订单信息：</div>
            <div>收款方：<span style="float: right">{{ info.prodKind === '1' ? '诚泰财产保险股份有限公司' : '益保（北京）科技有限公司'}}</span></div>
            <div style="margin: 10px 0;">订单号：<span style="float: right">{{account.outTradeNo}}</span></div>
            <div>商品名称：<span style="float: right">{{info.prodName}}</span></div>
            <div style="margin: 10px 0;">购买单价：<span style="float: right">{{account.price}}元</span></div>
            <div>参保人数：<span style="float: right">{{count}}</span></div>
            <div style="margin: 10px 0;">共计：<span style="float: right">{{account.amount / 100}}元</span></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "CheckDetail",
        data() {
            return {
                id: this.$route.query.id || '',
                info: {},
                count:'',
                account: {},
                memberList: []
            }
        },
        created() {
            this.$axios.get('/inspect/info',{params: {accountDetailId : this.id}}).then( res => {
                this.account = res.data.account
                this.count = res.data.count
                this.info = res.data.info
                this.memberList = res.data.member
            })
        }
    }
</script>

<style scoped>

</style>
